document.addEventListener("DOMContentLoaded", function () {
    const sections =  document.querySelectorAll(".review__container");
    sections.forEach(section => {
        const slider = section.querySelector(".swiper");
        if(!slider || slider.swiper) return
        const sliderPagination = section.querySelector(".reviews__pagination");


        const sliderConfig = {
            slidesPerView: "auto",
            loop: false,
            watchSlidesProgress: true,
            touchRatio: 1,
            threshold: 10,
            grabCursor: true,
        };


        if (sliderPagination) {
            sliderConfig.pagination = { el: sliderPagination, clickable: true };
        }

        try {
            const newInitSlider = new SwiperTheme(slider, sliderConfig);
        } catch (error) {
            throw new Error("Pleace check the class for initializations of slider:" + error)
        }
    })
});


